import React from "react";

const PhotoPlusStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.25 17.25H4.75C3.64543 17.25 2.75 16.3546 2.75 15.25V14M2.75 14V4.75C2.75 3.64543 3.64543 2.75 4.75 2.75H15.25C16.3546 2.75 17.25 3.64543 17.25 4.75V10.25L14.5856 7.43947C13.7663 6.48581 12.2815 6.51598 11.5013 7.50017L11.4914 7.51294C11.3977 7.63414 9.9621 9.4909 8.9257 10.8094M2.75 14L5.49619 10.5067C6.2749 9.5161 7.76453 9.4837 8.5856 10.4395L8.9257 10.8094M8.9257 10.8094L10.25 12.25M8.9257 10.8094C8.9221 10.814 8.9186 10.8185 8.915 10.823",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 12.75V17.25",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.25 15H12.75",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(PhotoPlusStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;